"use strict";

exports.__esModule = true;
var _UserAction = require("./UserAction");
Object.keys(_UserAction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserAction[key]) return;
  exports[key] = _UserAction[key];
});
var _UserActionFields = require("./UserActionFields");
Object.keys(_UserActionFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserActionFields[key]) return;
  exports[key] = _UserActionFields[key];
});
var _UserActionSelector = require("./UserActionSelector");
Object.keys(_UserActionSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserActionSelector[key]) return;
  exports[key] = _UserActionSelector[key];
});
var _userActionDefinitions = require("./userActionDefinitions");
Object.keys(_userActionDefinitions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _userActionDefinitions[key]) return;
  exports[key] = _userActionDefinitions[key];
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  exports[key] = _types[key];
});